// Single-open accordion for the home FAQ (port of FAQSection.tsx state).
export function initFaq() {
  document.querySelectorAll('[data-faq]').forEach((root) => {
    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    function setOpen(openIdx) {
      items.forEach((item, i) => {
        const open = i === openIdx;
        item.querySelector('[data-faq-btn]').setAttribute('aria-expanded', String(open));
        item.querySelector('[data-faq-answer]').hidden = !open;
        item.querySelector('[data-faq-icon]').dataset.open = String(open);
      });
    }
    items.forEach((item, i) => {
      item.querySelector('[data-faq-btn]').addEventListener('click', () => {
        const isOpen = item.querySelector('[data-faq-answer]').hidden === false;
        setOpen(isOpen ? -1 : i);
      });
    });
  });
}
